// components/FavoritesLoader.tsx

import { useFavoritesStore } from '@src/stores/favorites';
import { useLoginStore } from '@src/stores/login';
import { isBefore, isDate, subMinutes } from 'date-fns';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

export const FavoritesSettingsHandler = () => {
  const { status } = useSession() ?? {};
  const { fetchUserSettings } = useLoginStore(
    useShallow((state) => ({
      fetchUserSettings: state.fetchUserSettings,
    })),
  );
  const { lastFetched, fetchFavorites, handleTempFavorites, clearFavorites } = useFavoritesStore(
    useShallow((state) => ({
      favorites: state.favorites,
      lastFetched: state.lastFetched,
      fetchFavorites: state.fetchFavorites,
      handleTempFavorites: state.handleTempFavorites,
      clearFavorites: state.clearFavorites,
    })),
  );

  useEffect(() => {
    if (
      status === 'authenticated' &&
      (!lastFetched || !isDate(lastFetched) || isBefore(lastFetched, subMinutes(new Date(), 10)))
    ) {
      handleTempFavorites(fetchFavorites);
      fetchUserSettings();
    }

    if (status === 'unauthenticated') {
      clearFavorites();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearFavorites, fetchFavorites, lastFetched, status, fetchUserSettings, handleTempFavorites]);
  return null;
};
